export const T = {
  en_GB: {
    questionOf: (current: number, total: number) => `Question ${current} of ${total}`,
    previous: "Previous",
    next: "Next",
    finish: "Finish",
    passedTitle: "Passed",
    passedBody: "You answered enough questions correctly.",
    failedTitle: "Not passed",
    failedBody: "You did not answer enough questions correctly.",
    attemptsRemaining: (n: number) => `Attempts remaining: ${n}`,
    retryAvailableOn: (date: string) => `You can try again from ${date}.`,
    noAttemptsRemaining: "No attempts remaining. Ask your adviser to review this.",
    close: "Close",
    cancelTitle: "Leave the quiz?",
    cancelBody: "Your attempt stays open. You can resume the same questions later.",
    cancelConfirm: "Leave quiz",
    cancelDismiss: "Continue quiz",
    submitFailed: "Could not submit your answers. Please try again.",
  },
  nb_NO: {
    questionOf: (current: number, total: number) => `Spørsmål ${current} av ${total}`,
    previous: "Forrige",
    next: "Neste",
    finish: "Fullfør",
    passedTitle: "Bestått",
    passedBody: "Du svarte riktig på nok spørsmål.",
    failedTitle: "Ikke bestått",
    failedBody: "Du svarte ikke riktig på nok spørsmål.",
    attemptsRemaining: (n: number) => `Forsøk igjen: ${n}`,
    retryAvailableOn: (date: string) => `Du kan prøve igjen fra ${date}.`,
    noAttemptsRemaining: "Ingen forsøk igjen. Be rådgiveren din se på dette.",
    close: "Lukk",
    cancelTitle: "Forlate quizen?",
    cancelBody: "Forsøket ditt forblir åpent. Du kan fortsette med de samme spørsmålene senere.",
    cancelConfirm: "Forlat quiz",
    cancelDismiss: "Fortsett quiz",
    submitFailed: "Kunne ikke sende inn svarene dine. Prøv igjen.",
  },
} as const;
